import { render, staticRenderFns } from "./DriverDrawer.vue?vue&type=template&id=2de801a4&scoped=true&"
import script from "./DriverDrawer.vue?vue&type=script&lang=js&"
export * from "./DriverDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DriverDrawer.vue?vue&type=style&index=0&id=2de801a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de801a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle})
